(function () {
  'use strict';

  var INTERVAL_MS = 60;

  var urls = [
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/0_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/20_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/40_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/60_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/80_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/100_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/120_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/140_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/160_aquatix_indonesia_bali_spearfishing_freediving_favicon.png',
    'https://cdn.shopify.com/s/files/1/0737/4415/4865/files/180_aquatix_indonesia_bali_spearfishing_freediving_favicon.png'
  ];

  // Preload all frames so the browser has them cached before animation starts
  urls.forEach(function (url) {
    var img = new Image();
    img.src = url;
  });

  // Find or create the <link rel="icon"> element
  var linkEl = document.querySelector('link[rel="icon"]');
  if (!linkEl) {
    linkEl = document.createElement('link');
    linkEl.rel = 'icon';
    document.head.appendChild(linkEl);
  }

  var frame = 0;

  setInterval(function () {
    linkEl.href = urls[frame];
    frame = (frame + 1) % urls.length;
  }, INTERVAL_MS);
})();
